import React from 'react'
import Jobs from '../Jobs'
import { PageTitle } from '../WaldoStyle'

export default function JobsPage() {
    return <div>
        <PageTitle>JOBS</PageTitle>
        <Jobs />
    </div>
}